/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/exclamation_triangle'
export default icon
